{
  "SITE_GAPS_MAP": {
    "eventId": 356,
    "params": [
      "above_header",
      "above_page",
      "above_footer"
    ]
  },
  "MESH_MIGRATION": {
    "eventId": 410,
    "params": [
      "status",
      "reasonid",
      "pages_count"
    ]
  },
  "MESH_MIGRATION_PRESAVE": {
    "eventId": 424,
    "params": [
      "status",
      "reasonid",
      "pages_count"
    ]
  },
  "MESH_MIGRATION_WIZARD": {
    "eventId": 426,
    "params": [
      "status",
      "reasonid",
      "pages_count"
    ]
  },
  "AUTO_SAVE_DIFFS_RESTORED": {
    "eventId": 623,
    "params": []
  },
  "FULL_DOCUMENT_SAVE_ATTEMPTED_AFTER_PARTIAL_FAILURE": {
    "eventId": 632,
    "params": [
      "endpoint"
    ]
  },
  "DATA_ITEM_REFS_SAVE_DATAFIXER": {
    "src": 38,
    "eventId": 659,
    "params": {
      "dataType": "dataType",
      "dataItemType": "dataItemType"
    }
  },
  "PLATFORM_API_CALL": {
    "endpoint": "platform",
    "src": 79,
    "evid": 24,
    "params": [
      "app_name",
      "module",
      "function",
      "arguments",
      "pageId"
    ]
  },
  "PLATFORM_API_CALL_HYBRID_METHODS": {
    "endpoint": "platform",
    "src": 79,
    "evid": 370,
    "params": [
      "appDefinitionId",
      "module",
      "function",
      "arguments",
      "pageId"
    ]
  },
  "PLATFORM_API_CALL_DURATION": {
    "endpoint": "platform",
    "src": 79,
    "evid": 421,
    "params": [
      "appDefinitionId",
      "module",
      "editorType",
      "function",
      "duration",
      "pageId"
    ]
  },
  "SECTION_LAYOUT_MIGRATION_REPARENT": {
    "endpoint": "editor",
    "src": 38,
    "evid": 753,
    "params": [
      "component_id",
      "z_index_changed",
      "new_container_id"
    ]
  },
  "SECTION_LAYOUT_MIGRATION_CLOSE_GAP": {
    "endpoint": "editor",
    "src": 38,
    "evid": 754,
    "params": [
      "gap_size",
      "gap_type",
      "is_closed"
    ]
  },
  "SECTION_LAYOUT_MIGRATION_RUN": {
    "endpoint": "editor",
    "src": 38,
    "evid": 757,
    "params": []
  },
  "EDITOR_PLATFORM_APPS_LOADED": {
    "endpoint": "platform",
    "src": 79,
    "evid": 25,
    "params": [
      "app_list",
      "number_of_apps"
    ]
  },
  "MOVE_STYLE_TO_PAGES_MIGRATION": {
    "endpoint": "document",
    "src": 40,
    "evid": 101,
    "params": [
      "mp_styles_before",
      "mp_styles_after",
      "page_styles_after",
      "errorReason",
      "duration",
      "esi",
      "dsOrigin"
    ]
  },
  "PREVIEW_SITE_READY": {
    "endpoint": "document",
    "eventId": 103,
    "src": 40,
    "params": [
      "dsOrigin",
      "esi",
      "viewerName"
    ]
  },
  "SCHEMA_BY_COMP_TYPE": {
    "endpoint": "document",
    "eventId": 14,
    "src": 40,
    "sampleRatio": 10,
    "params": [
      "componentType",
      "schemaType",
      "schemaName",
      "dsOrigin"
    ]
  },
  "REF_TYPE_FOR_SCHEMA": {
    "endpoint": "document",
    "eventId": 15,
    "src": 40,
    "sampleRatio": 40,
    "params": [
      "schemaType",
      "schemaName",
      "ref",
      "parentSchema",
      "dsOrigin"
    ]
  },
  "DOCUMENT_SERVICES_LOADED": {
    "endpoint": "document",
    "eventId": 102,
    "src": 40,
    "params": [
      "dsOrigin",
      "esi",
      "viewerName"
    ]
  },
  "PLATFORM_WORKER_LOADED": {
    "endpoint": "document",
    "eventId": 13,
    "src": 40,
    "params": [
      "dsOrigin",
      "viewerName",
      "ts"
    ]
  },
  "DEPRECATED_PUBLIC_API_CALL": {
    "endpoint": "document",
    "eventId": 105,
    "src": 40,
    "params": [
      "methodName",
      "dsOrigin"
    ]
  },
  "FIX_MISSING_COMPONENT_STYLE": {
    "endpoint": "document",
    "eventId": 106,
    "src": 40,
    "params": [
      "dsOrigin",
      "componentType",
      "style"
    ]
  }
}
